const DELAY = 3000;

export default function delayLoginReload() {
  return new Promise((resolve) => setTimeout(resolve, DELAY));
}
